module.exports = __webpack_public_path__ + "img/lion.c9fe8b6d.png";